import React, { useState, useEffect } from 'react';
import { Grid, Typography, InputLabel } from '@material-ui/core';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import { SecondaryButton, TextBox, PasswordBox } from '../../../Core/FormInput';
import { getGraphMailSettings, addGraphMailSettings } from '../../../Core/Service/Settings';

const crumbs = [
    { name: 'Home', path: '/' },
    // { name: 'Settings', path: '/' },
    { name: 'Graph Mail Settings', path: '/Graph-mail-settings', active: true }
];

const MailSettingsForm = (props) => {
    const [settings, setSettings] = useState({
        tenantId: '',
        clientId: '',
        senderUserObjectId: '',
        secretKey: ''
    });

    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        setIsLoading(true);
        try {
            const res = await getGraphMailSettings();
            const settingsData = res?.data?.list?.[0] || res?.response;
            if (settingsData) {
                setSettings({
                    tenantId: settingsData.tenantId || '',
                    clientId: settingsData.clientId || '',
                    senderUserObjectId: settingsData.senderUserObjectId || '',
                    secretKey: settingsData.secretKey || ''
                });
            }
        } catch (error) {
            console.error('Error fetching Graph Mail Settings:', error);
            setMessage('Failed to load existing settings.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setSettings((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        setMessage('Saving...');
        try {
            const res = await addGraphMailSettings(settings);
            if (res?.data?.success || res?.success) {
                setMessage(res?.data?.message || res?.message || 'Configuration saved successfully!');
            } else {
                setMessage('Failed to save configuration.');
            }
        } catch (error) {
            console.error('Error saving Graph Mail Settings:', error);
            setMessage('An error occurred while saving.');
        }
    };

    return (
        <div style={{}}>
            <BreadCrumbs crumbs={crumbs} />
            <Grid container style={{ padding: 20 }}>
                {isLoading ? (
                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                        <Typography variant="body1">Loading settings...</Typography>
                    </Grid>
                ) : (
                    <Grid container style={{ textAlign: 'left' }} spacing={2}>
                        <Grid xs={12} sm={6} md={4} container item>
                            <Grid item xs={12}>
                                <InputLabel>Tenant ID</InputLabel>
                                <TextBox name="tenantId" value={settings.tenantId} placeholder="Enter Tenant ID" onChange={handleFieldChange} />
                            </Grid>
                        </Grid>

                        <Grid xs={12} sm={6} md={4} container item>
                            <Grid item xs={12}>
                                <InputLabel>Client ID</InputLabel>
                                <TextBox name="clientId" value={settings.clientId} placeholder="Enter Client ID" onChange={handleFieldChange} />
                            </Grid>
                        </Grid>

                        <Grid xs={12} sm={6} md={4} container item>
                            <Grid item xs={12}>
                                <InputLabel>Sender User Object ID</InputLabel>
                                <TextBox
                                    name="senderUserObjectId"
                                    value={settings.senderUserObjectId}
                                    placeholder="Enter Sender User Object ID"
                                    onChange={handleFieldChange}
                                />
                            </Grid>
                        </Grid>

                        <Grid xs={12} container item>
                            <Grid item xs={12}>
                                <InputLabel>Secret Key</InputLabel>
                                <PasswordBox name="secretKey" value={settings.secretKey} placeholder="Enter Secret Key" onChange={handleFieldChange} />
                            </Grid>
                        </Grid>
                        {message && (
                            <Typography variant="body2" style={{ color: message.includes('success') ? 'green' : '#d32f2f', marginBottom: '10px' }}>
                                {message}
                            </Typography>
                        )}

                        <Grid item xs={12} container spacing={2} style={{ marginTop: '10px', paddingLeft: '8px' }}>
                            <Grid item xs={12} sm={6} className="submit_btn" style={{ textAlign: 'center' }}>
                                <SecondaryButton fullWidth onClick={handleSubmit}>
                                    Save
                                </SecondaryButton>
                            </Grid>
                            <Grid item xs={12} sm={6} className="submit_btn" style={{ textAlign: 'center' }}>
                                <SecondaryButton
                                    fullWidth
                                    onClick={() => {
                                        if (props.history) props.history.push('/');
                                    }}
                                >
                                    Cancel
                                </SecondaryButton>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </div>
    );
};

export default MailSettingsForm;
